module.exports = {
	"name": "spectra-data",
	"version": "3.1.10",
	"description": "spectra-data project - manipulate spectra",
	"keywords": [
		"spectra-data",
		"project"
	],
	"files": [
		"src"
	],
	"author": "Andres Castillo",
	"contributors": [
		"Michaël Zasso",
		"Luc Patiny"
	],
	"repository": "cheminfo-js/spectra",
	"bugs": {
		"url": "https://github.com/cheminfo-js/spectra/issues"
	},
	"homepage": "https://github.com/cheminfo-js/spectra/packages/spectra-data",
	"license": "MIT",
	"main": "./src/index.js",
	"devDependencies": {
		"nmr-predictor": "^1.0.9"
	},
	"dependencies": {
		"brukerconverter": "^1.0.1",
		"jcampconverter": "^2.4.5",
		"ml-array-utils": "^0.3.0",
		"ml-curve-fitting": "^0.0.7",
		"ml-fft": "^1.3.5",
		"ml-gsd": "^2.0.1",
		"ml-matrix-peaks-finder": "^0.2.1",
		"ml-simple-clustering": "^0.1.0",
		"ml-stat": "^1.3.0",
		"nmr-simulation": "^1.0.6",
		"spectra-data-ranges": "^0.0.7",
		"spectra-nmr-utilities": "^0.0.5"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/spectra-data/package.json
// module id = 142
// module chunks = 0